/*
*
* File JS per il template Landing Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSection from 'components/heroes/hero-section';
import halfTextBg from 'components/half-txt-bg/half-txt-bg';
import halfTextImg from 'components/half-txt-img/half-txt-img';
import blockVideo from 'components/block-video/block-video';
import blockFaq from 'components/block-faq/block-faq';
import blockBanner from 'components/block-banner/block-banner';
import col2TxtImg from 'components/col2_txt_img/col2_txt_img';
import col2TxtImgSlider from 'components/col2_txt_img_slider/col2_txt_img_slider';
import blockTitle from 'components/block-title/block-title';
import blockVideoTabs from 'components/block-video-tabs/block-video-tabs';
import blockImage from 'components/block-image/block-image';
import submenu from 'components/submenu/submenu';
import iconText from 'components/icon-text/icon-text';
import blockImages from 'components/block-images/block-images';
import table from 'components/table/table';
import blockForm from 'components/block-form/block-form';
import blockText from 'components/block-text/block-text';
import col2TxtVideo from 'components/col2_txt_video/col2_txt_video';
import icontInteractive from 'components/icon-interactive/icon-interactive';
import blockQuote from 'components/block-quote/block-quote';
import blockCaseStudy from 'components/block-case-study/block-case-study';
import sliderFullImg from 'components/slider-full-img/slider-full-img';
import slider from 'components/slider/slider';
import halfTextBgMap from 'components/half-txt-bg-map/half-txt-bg-map';


// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockFaq();
col2TxtImgSlider();
blockVideoTabs();
submenu();
iconText();
blockForm();
col2TxtVideo();
icontInteractive();
blockQuote();
blockCaseStudy();
sliderFullImg();
slider();
halfTextBgMap();

//--------------------------------------------------------------------//